import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'

export const SC_DocumentCard = styled.div`
  background-color: ${E_Colors.White};
  border-radius: 15px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h5 {
    font-weight: 700;
    font-size: 17px;
  }
`

export const SC_DocumentCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SC_DocumentCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`